import axios from "axios";
import qs from 'qs';

export default {
  setOrders({commit, getters, state}, {
    type,
    filters,
    archived = false
  }) {
    const setFilters = () => {
      let data = {...filters};

      delete data.tab;
      delete data.page;

      if (data.statuses) {
        data.statuses = getters.filterStatusList(data.statuses);
      }

      if (data.employees) {
        data.employees = getters.filterEmployeeList(data.employees);
      }

      if (data.type) {
        data.type = data.type.split(',');
      }

      if (data.company) {
        data.dealer_company_id = data.company;
        delete data.company;
      }

      if (data.dealer) {
        data.contractor = data.dealer;
        delete data.dealer;
      }

      return data;
    };

    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/${type.toLowerCase()}/${archived ? 'archived' : 'actual'}`, {
        params: {
          'page': state.page,
          'per_page': state.per_page,
          'filters': setFilters(),
        },
        paramsSerializer: function (params) {
          return qs.stringify(params, {encode: false});
        },
      }).then(res => {
        resolve(res.data);
        if (archived) {
          commit(`update${type}OrderArchived`, res.data);
        } else {
          commit(`update${type}Order`, res.data);
        }
      }, error => {
        reject(error)
      })
    })
  },

  createReclamation({commit, getters}, data) {
    return new Promise((resolve, reject) => {
      let body = data;
      if (getters.isDealer) {
        body.from_dealer = true;
      }

      axios.post(`${process.env.VUE_APP_API_URL}/api/reclamations/create`, body).then(res => {
        if (res.data.number) {
          data.order.items.forEach(({id}) => {
            commit('updateOrderDetailItemsReclamation', id);
          })
          commit('updateOrderDetailReclamation');
        }
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },

  /**
   * Список статусов
   * @param commit
   * @returns {Promise<unknown>}
   */
  setStatusList({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/statuses`).then(res => {
        resolve(res.data);
        commit('updateStatusList', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  /**
   * Добавление значения "В любом статусе"
   * @param commit
   */
  addEmptyStatus({commit}) {
    commit('addEmptyStatus', {id: null, 'name': 'Все заказы'});
  },

  // инфо о заказе
  setOrderDetail({commit}, {uuid}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/${uuid}/info`).then(res => {
        resolve(res.data);
        commit('updateOrderDetail', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  setOrderDetailShort({commit}, {uuid}) {
    commit('updateOrderDetail', null);
    commit('updatePositions', uuid);

    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/orders/${uuid}/info?view=items`).then(res => {
        resolve(res.data);
        commit('updateOrderDetail', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  //передать заказы в архив
  orderSendArchive({commit}, selected) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/move-to-archive`, selected).then(res => {
        resolve(res.data)
      }, error => {
        reject(error)
      })
    })
  },

  orderReturn({commit}, {selected, commentData}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/return-to-revision`, {
        'commentData': commentData,
        'selected': selected,
      }).then(res => {
        resolve(res.data)
      }, error => {
        reject(error)
      })
    })
  },

  orderSendSupplier({commit}, {selected, commentData}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/send-to-suppliers`, {
        'commentData': commentData,
        'selected': selected,
      }).then(res => {
        resolve(res.data)
      }, error => {
        reject(error)
      })
    })
  },

  // Сформировать заказы
  orderCreate({commit}, {selected, commentData}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/create-to-suppliers`, {
        'selected': selected,
        'commentData': commentData,
      }).then(res => {
        resolve(res.data)
      }, error => {
        reject(error)
      })
    })
  },

  addComment({commit}, {uuid, data}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/${uuid}/add-comment`, data).then(res => {
        resolve(res.data);
        commit('updateOrderDetailComments', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  setOrderStatus({commit}, {uuid, status, commentData, type}) {
    commit('common/updatePreload', '', {root: true});
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/${uuid}/change-status`, {
        status,
        commentData,
      }).then(res => {
        resolve(res.data);
        commit('updateOrderDetailStatus', res.data.status);
        commit('updateOrderDetailComments', res.data);
        commit('updateOrderitemStatus', {
          'type': type,
          'uuid': uuid,
          'status': res.data.status,
        });
        commit('common/updatePreload', '', {root: true});
      }, error => {
        reject(error)
      })
    })
  },

  updateOrderDetailEmployee({commit}, {uuid, employee, type, notify}) {
    return new Promise((resolve, reject) => {
      commit('common/updatePreload', '', {root: true});
      let data = {
        'dealer_employee_id': employee.id,
        'notify': notify,
      };

      if (notify) {
        data.notify = notify;
      }

      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/${uuid}/change`, data).then(res => {
        resolve(res.data);
        commit('updateOrderEmployee', {
          'type': type,
          'uuid': uuid,
          'employee': employee.id === null ? null : employee,
        });
        commit('common/updatePreload', '', {root: true});
      }, error => {
        reject(error)
      })
    })
  },

  setOrderDetailOuterNumber({commit, getters}, {outer_number, type}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/${getters.getOrderDetailUiid}/change`, {
        outer_number,
      }).then(res => {
        resolve(res.data);
        commit('updateOrderDetailOuterNumber', {
          uuid: getters.getOrderDetailUiid,
          outer_number,
          type,
        });
      }, error => {
        reject(error)
      })
    })
  },

  setOrderDetailFiles({commit, getters}, files) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/${getters.getOrderDetailUiid}/change`, {
        files
      }).then(res => {
        resolve(res.data);
        if (res.data.comments) {
          commit('updateOrderDetailComments', res.data.comments);
        }
      }, error => {
        reject(error)
      })
    })
  },

  deleteOrderDetailFiles({commit, getters}, uuid) {
    return new Promise((resolve, reject) => {
      axios.delete(`${process.env.VUE_APP_API_URL}/api/orders/${getters.getOrderDetailUiid}/files/${uuid}`).then(res => {
        resolve(res.data);
        commit('updateDeleteOrderDetailFile', uuid);
        if (res.data.comment) {
          commit('updateOrderDetailComments', res.data.comment);
        }
      }, error => {
        reject(error)
      })
    })
  },

  updateClientInfo({commit}, {uuid, info}) {
    return new Promise((resolve, reject) => {
      commit('common/updatePreload', '', {root: true});
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/${uuid}/change`, {
        'customer_name': info.name,
        'customer_phone': info.phone,
        'customer_email': info.email,
        'customer_address': info.address,
      }).then(res => {
        resolve(res.data);
        commit('updateOrderDetailCustomer', info);
        commit('common/updatePreload', '', {root: true});
      }, error => {
        reject(error);
        commit('common/updatePreload', '', {root: true});
      })
    })
  },

  updateClientInfoDate({commit}, body) {
    return new Promise((resolve, reject) => {
      commit('common/updatePreload', '', {root: true});
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/${body.uuid}/change`, {
        'made_at': body.made_at,
        'shipped_at': body.shipped_at,
      }).then(res => {
        resolve(res.data);
        commit('updateOrderDetailDate', body);
        commit('updateOrderitemDate', body);
        commit('common/updatePreload', '', {root: true});
      }, error => {
        reject(error);
        commit('common/updatePreload', '', {root: true});
      })
    })
  },

  updateClientInfoPaid({commit}, body) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/${body.uuid}/change`, {
        'paid_at': body.paid_at,
      }).then(res => {
        resolve(res.data);
        commit('updateOrderDetailPaid', body);
      }, error => {
        reject(error)
      })
    })
  },

  deleteOrder({commit}, uuid) {
    return new Promise((resolve, reject) => {
      axios.delete(`${process.env.VUE_APP_API_URL}/api/orders/${uuid}`).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },
}
